import { jsx as _jsx } from "react/jsx-runtime";
import { _className, TS_Checkbox } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
export const Q_Checkbox = (props) => {
    const { className, ...rest } = props;
    const cbClassName = _className('quai', className);
    return _jsx(TS_Checkbox, { ...rest, className: cbClassName, icon: _jsx(ICONS.v.component, {}) });
};
//# sourceMappingURL=Q_Checkbox.js.map